import { Button, ModalBody, ModalHeader } from 'reactstrap';
import PropTypes from 'prop-types';
import Modal from './Modal';

/**
 * A generic confirmation modal component.
 * @param props: see PropTypes, below.
 * @returns a confirmation modal component.
 */
const ConfirmationModal = ({
  title = null,
  actionDescriptionSentence,
  actionQuestion = 'Are you sure?',
  actionName,
  disabledActionName = null,
  cancelName = 'Cancel',
  closeName = null,
  onCancel,
  onConfirm,
  onClose = null,
  actionDisabled = false,
  children = null,
  ...modalProps
}) => (
  <Modal {...modalProps}>
    {title && (
      <ModalHeader tag="div">
        <h2 className="m-0">{title}</h2>
      </ModalHeader>
    )}
    <ModalBody>
      <p className="font-medium">
        {actionDescriptionSentence ? `${actionDescriptionSentence} ` : ''}
        {actionQuestion}
      </p>
      {children && <div>{children}</div>}
      <div className="d-flex justify-content-end">
        {closeName && onClose && (
          <Button className="mr-2" type="button" size="sm" onClick={onClose}>
            {closeName}
          </Button>
        )}
        <Button className="mr-2" type="button" size="sm" onClick={onCancel}>
          {cancelName}
        </Button>
        <Button
          color="primary"
          type="button"
          size="sm"
          onClick={onConfirm}
          disabled={!!actionDisabled}
        >
          {(!!actionDisabled && disabledActionName) || `Yes, ${actionName}`}
        </Button>
      </div>
    </ModalBody>
  </Modal>
);

ConfirmationModal.propTypes = {
  title: PropTypes.string, // title of modal
  actionDescriptionSentence: PropTypes.string, // sentence describing action that the modal is confirming,
  actionQuestion: PropTypes.string, // question to ask at the end of the prompt. Default: "Are you sure?"
  actionName: PropTypes.string.isRequired, // name of the action, to be rendered in the confirmation button.
  cancelName: PropTypes.string, // name of cancellation action. Default: "Cancel"
  onCancel: PropTypes.func, // () => void. Function executed when the user clicks "cancel."
  onConfirm: PropTypes.func, // () => void. Function executed when the user clicks "confirm."
  isOpen: PropTypes.bool.isRequired, // Whether or not the modal is open.
  // plus all props belonging to reactstrap's Modal component
};

export default ConfirmationModal;
